import { Component } from 'react'
import moment from 'moment'
import { updateJobApply } from '../../../../../insfrastructure/services/job-applies'
import Modal from '../../../../components/modal'
import { SubmitBtn } from '../../../../components/submit'
import successIcon from '../../../../../assets/icons/success.png'
import './styles.sass'
import { Input } from '../../../../components/input'
import { emptyField, ErrorMessage, errorsLength, formatErrors } from '../../../../../insfrastructure/utils/form-validators'
import ResponseModal from '../../../../components/response-modal'

interface ModalProps {
    render: boolean,
    candidate: any,
    jobapply_id: any,
    onClose: () => void,
    onSubmitted: () => void
}

export default class ApproveModal extends Component<ModalProps> {
    state: any = {
        form: {},
        formErrors: {},
        loading: false
    }

    componentDidUpdate(prevProps: Readonly<ModalProps>, prevState: Readonly<{}>, snapshot?: any): void {
        if (prevProps.render !== this.props.render) {
            this.setState({ 
                form: {},
                formErrors: {},
                loading: false
            });    
        };
    }

    onSubmit = async () => {
        if(this.state.loading) return;

        const errors = formatErrors({
            hired_date: [emptyField(this.state.form.hired_date)]
        });

        this.setState({ formErrors: errors });

        if(errorsLength(errors) > 0) return;

        try {
            this.setState({ loading: true });

            await updateJobApply(this.props.jobapply_id, {
                status: 'hired',
                hired_date: moment(this.state.form.hired_date).format('YYYY-MM-DD')
            });

            setTimeout(() => {
                let responseData = {
                    type: 'success',
                    title: 'Candidato aprovado com sucesso!'
                };
            
                this.setState({ loading: false, responseData });
            }, 500);
        } catch (error) {
            
        };

        setTimeout(() => {
            this.setState({ loading: false });
            this.props.onSubmitted();
        }, 500);
    }

    render() {
        return (
            <>
                <Modal render={this.props.render && !this.state.responseData} onClose={() => this.props.onClose()}>
                    <div className='approve-modal'>
                        <div className='modal-header'>
                            <img src={successIcon} alt='success-icon' />
                            <h4><b>{this.props.candidate && this.props.candidate.name}</b> foi contratado(a)?</h4>
                        </div>
                        <p>Tem certeza dessa ação? Ao realizá-la, a vaga concorrida será preenchida.</p>
                        <form>
                            <Input
                            name='hired_date'
                            label='Data:'
                            showTimeSelect={false}
                            type='date'
                            value={this.state.form.hired_date}
                            dateFormat='dd/MM/yyyy'
                            onChange={(e) => {
                                this.setState({ form: { ...this.state.form, hired_date: e }});
                            }}/>
                            <ErrorMessage errors={this.state.formErrors['hired_date']} />
                        </form>
                        <SubmitBtn
                        className='primary'
                        text='Sim, tenho certeza'
                        loadingText='Carregando...'
                        onSubmit={this.onSubmit}
                        loading={this.state.loading} />
                    </div>
                </Modal>
                <ResponseModal
                render={this.state.responseData}
                type={this.state.responseData?.type}
                title={this.state.responseData?.title}
                text={this.state.responseData?.text}
                onClose={() => {
                    this.setState({ responseData: null });
                    this.props.onSubmitted();
                }} />
            </>
        )
    }
}
